<template>
    <div class="bg-a-egg-f5ebdc min-h-screen">
        <UltimateTopBar></UltimateTopBar>
        <ProfileBar></ProfileBar>
        <ShoppingBag></ShoppingBag>
        <Notification></Notification>
        <Subscription></Subscription>
        <div class="content-page mx-auto" :class="[pageClass, cookieClass]">
            <div v-if="isShowDelivery" class="block lg:hidden">
                <DeliveryBox></DeliveryBox>
            </div>
            <slot></slot>
        </div>
        <MainFooter :hideMobile="hideMainFooterMobile"></MainFooter>
        <MenuMobileFooter></MenuMobileFooter>
    </div>
</template>
<script>
import UltimateTopBar from '../TopBar/UltimateTopBar/UltimateTopBar.vue';
import DeliveryBox from './HomeLayout/DeliveryBox.vue';
import MainFooter from '../Footer/MainFooter.vue';
import MenuMobileFooter from '../Footer/MenuMobileFooter/MenuMobileFooter.vue';
import ShoppingBag from '../SideMenu/ShoppingBag.vue';
import ProfileBar from '../SideMenu/ProfileBar.vue';
import Notification from '../SideMenu/Notification.vue';
import Subscription from '../SideMenu/Subscription.vue';
import CookieMixin from '../../../mixin/CookieMixin.js';
import AuthStatusMixin from '../../../mixin/AuthStatusMixin.js';
import ConsentMixin from '../../../mixin/ConsentMixin.js';

export default {
    mixins: [CookieMixin, AuthStatusMixin, ConsentMixin],
    props: {
        isShowDelivery:     { type: Boolean, default: true },
        customClass: { type: String, default: null },
        hideMainFooterMobile: { type: Boolean, default: false },
    },
    components: {
        UltimateTopBar,
        DeliveryBox,
        MainFooter,
        MenuMobileFooter,
        ShoppingBag,
        Subscription,
        ProfileBar,
        Notification,
    },
    computed: {
        pageClass: function () {
            if (this.customClass != null) {
                return this.customClass;
            }
            return 'container';
        },
    },
    methods: {
        onAccountInit: function () {
            this.checkConsent();
        },
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .content-page {
        padding-top: $topbar-height;
        min-height: 100vh;

        &.accept-cookie {
            padding-top: 140px;

            @media (min-width: 1024px) {
                padding-top: 108px;
            }
        }
    }
</style>
